require('./bootstrap');
import router from './router'

import 'vuetify/dist/vuetify.min.css'
import Vue from 'vue';
import Vuetify from 'vuetify';
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookie from 'vue-cookie'
import eventBus from './plugins/EventBus'
import store from './plugins/Store'
import gameData from "./plugins/GameData";
import resultData from "./plugins/ResultData";
import App from "./App.vue"

import moment from 'moment'
import vueMoment from 'vue-moment'

import AudioController from "./plugins/AudioController"

// import colors from 'vuetify/lib/util/colors'


Vue.use(Vuetify);

Vue.mixin(AudioController)

global.jQuery = require('jquery');
const $ = global.jQuery;
window.$ = $;

Vue.config.productionTip = false

Vue.use(VueAxios, axios)
Vue.use(VueCookie)
Vue.use(eventBus)
Vue.use(gameData)
Vue.use(resultData)

Vue.use(vueMoment, moment)

window.vm = new Vue({
    vuetify: new Vuetify({
        theme: {
            themes: {
                light: {
                    // primary: colors.red.darken1, // #E53935
                    // secondary: colors.red.lighten4, // #FFCDD2
                    // accent: colors.indigo.base, // #3F51B5
                },
            },
        },
        icons: {
            iconfont: 'mdi'
        },
    }),
    eventBus,
    store,
    gameData,
    resultData,
    router,
    render: h => h(App),
}).$mount('#app');
